import _ from 'lodash';
import { Product } from './Product';

const _ChannelAssumptions = {};

_ChannelAssumptions[Product.channels.CAS.code] = {
  settings: {
    channel: Product.channels.CAS,
    product: Product.products.CASTerm,
  },
  defaults: {
    age: '35',
    face: 1e5,
    gender: 'male',
    health: 0,
    term: 20,
    smoker: false,
    zip: '01111',
  },
};

_ChannelAssumptions['MM'] = {
  settings: {
    channel: Product.channels.CAS,
    product: Product.products.CASTerm,
  },
  defaults: {
    age: '35',
    face: 1e5,
    gender: 'male',
    health: 0,
    term: 20,
    smoker: false,
    zip: '01111',
  },
};

_ChannelAssumptions[Product.channels.MMDirect.code] = {
  settings: {
    channel: Product.channels.MMDirect,
    product: Product.products.CASTerm,
  },
  defaults: {
    age: '35',
    face: 100000,
    gender: 'male',
    health: 0,
    term: 20,
    smoker: false,
    zip: '01111',
  },
};

const productCodes = {};

function keyBy(_code, data) {
  const res = {};

  _.each(data, (elem, key) => {
    res[key] = elem.code;
  });

  return res;
}

export const ChannelAssumptions = _ChannelAssumptions;
